import {Pipe, PipeTransform} from "@angular/core";
import {LeagueCompetitorStanding, LeaguePoints} from "@model";

@Pipe({
    name: 'resultByRound',
    standalone: false
})
export class ResultByRoundPipe implements PipeTransform {
    transform(competitorResult: LeagueCompetitorStanding, eventId: number, raceIds: number[]): LeaguePoints | undefined {
        if (!competitorResult.pointsByRound || !raceIds?.length) return undefined;
        const raceId = raceIds.find(id => (competitorResult.pointsByRound as any)[id] != null);
        return raceId != null ? (competitorResult.pointsByRound as any)[raceId] : undefined;
    }
}